import * as React from 'react'
// components
import PlanEdit from 'components/PageComponents/Plans/Edit/index'
import LinkingModeAPI from 'containers/Plan/Edit/layers/API/Linking'
import PageEditPageAPI from 'containers/Plan/Edit/layers/API/index'

const PlanEditContainer: React.FC = () => (
  <PageEditPageAPI>
    <LinkingModeAPI>
      <PlanEdit />
    </LinkingModeAPI>
  </PageEditPageAPI>
)

export default PlanEditContainer
